class FilmsPage {
    constructor() {
        this.init_hash_listener();
        this.filter_films(location.hash.slice(1));
    }

    filter_films(hash) {
        console.log("Filtering by: ", hash);
        if (hash && window.film_types && typeof window.film_types === 'object') {
            if (hash in window.film_types) {
                document.querySelectorAll('.cat_tab').forEach(v => {
                    v.querySelector('a').classList.remove('active');
                    if (v.classList.contains(`${hash}_filter`)) {
                        v.querySelector('a').classList.add('active');
                    }
                });

                document.querySelectorAll('.film_card').forEach(v => {
                    if (v.classList.contains(hash)) v.style.display = 'block';
                    else v.style.display = 'none';
                });
            }
        }
    }

    init_hash_listener() {
        document.addEventListener('new_hash', e => {
            this.filter_films(e.detail.hash);
        });
    }
}

let film_page;
document.addEventListener("DOMContentLoaded", () => {
    film_page = new FilmsPage();
});
